/**
 * Copy Bienenwanderung
 * @param year
 */
window.copyBienenwanderung = function(year) {
  var bienenIDs = '';
  $('input.select-bienenwanderung:checked').each(function() {
    if (bienenIDs === '') {
      bienenIDs = $(this).val();
    } else {
      bienenIDs += ',' + $(this).val();
    }
  });
  if (bienenIDs !== '') {
    ajaxDialog(BASE_PATH + 'ajax/dialog/copyBienenwanderung.php?ids=' + bienenIDs + '&year=' + year, 400);
  }
};

/**
 * Copy Bienenwanderung Weinbau
 * @param year
 */
window.copyEinschraenkungenWeinbau = function(year) {
  var bienenIDs = '';
  $('input.select-bienenwanderung:checked').each(function() {
    if (bienenIDs === '') {
      bienenIDs = $(this).val();
    } else {
      bienenIDs += ',' + $(this).val();
    }
  });
  if (bienenIDs !== '') {
    ajaxDialog(BASE_PATH + 'ajax/dialog/copyBienenwanderungWeinbau.php?ids=' + bienenIDs + '&year=' + year, 400);
  }
};

/**
 * Sorte aktualisieren anhand der KulturID
 * @param element
 * @returns {boolean}
 */
window.checkKultur = function(element) {
  var kulturVal = $(element).val();
  $.ajax({
    url: BASE_PATH + 'ajax/helper/matchSorte',
    type: 'get',
    data: {
      kulturCode: kulturVal,
    },
    success: function(html) {
      $(element).closest('form').find('ul.sorte-auswahl').html(html);
      $(element).closest('form').find('ul.sorte-auswahl').find('li').removeClass('checked');
    },
  });

  return false;
};

/**
 * changeBezeichnung
 * @param element
 */
window.changeBezeichnung = function(element) {
  $(element).closest('form').find('ul.bezeichnung-auswahl').html('');

  var qualitaet_code = $('#u-qualitaet-code').val();
  var type = $('#u-type').val();

  $.ajax({
    url: BASE_PATH + 'ajax/helper/matchBezeichnung',
    type: 'get',
    data: {
      qualitaet_code: qualitaet_code,
      culture_uid: 400,
      type: type,
    },
    success: function(html) {
      $(element).closest('form').find('ul.bezeichnung-auswahl').html(html);
      $(element).closest('form').find('ul.bezeichnung-auswahl').find('li').removeClass('checked');
    },
  });
};

/**
 * checkSelectAll
 * @param element
 * @param field
 */
window.checkSelectAll = function(element, field = 'sorte') {
  const checked = $(element).prop('checked');
  if (parseInt($(element).val()) === 0) {
    $(element).closest('.' + field + '-auswahl').find('li').each(function() {
      if (parseInt($(this).find('input:checkbox').val()) !== 0) {
        $(this).find('input:checkbox').prop('checked', checked);
        if (checked === true) {
          $(this).addClass('checked');
        } else {
          $(this).removeClass('checked');
        }
      }
    });
  } else {
    let allChecked = true;
    $(element).closest('.' + field + '-auswahl').find('li').each(function() {
      if (parseInt($(this).find('input:checkbox').val()) !== 0 && $(this).find('input:checkbox').prop('checked') === false) {
        allChecked = false;
      }
    });

    if (allChecked) {
      $(element).closest('.' + field + '-auswahl').find('li.first').addClass('checked').find('input:checkbox').prop('checked', true);
    } else {
      $(element).closest('.' + field + '-auswahl').find('li.first').removeClass('checked').find('input:checkbox').prop('checked', false);
    }
  }
};

/**
 * changeColor
 * @param element
 */
window.changeColor = function(element) {
  if ($(element).is(':checked')) {
    $(element).closest('li').addClass('checked');
  } else {
    $(element).closest('li').removeClass('checked');
  }
};

/**
 * changeEinsatz
 */
window.changeEinsatz = function() {
  if ($('#u-ab-bluehbeginn').prop('checked') === true) {
    $('#u-date_from').val('').removeClass('err').prop('disabled', true);
    $('#u-date_to').val('').removeClass('err').prop('disabled', true);
  } else {
    $('#u-date_from').prop('disabled', false);
    $('#u-date_to').prop('disabled', false);
  }
};
